import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import Consulting from '../Consulting/Consulting';

export default function ConsultingServices() {
  return (
    <div>
      <Navbar />
      <Consulting />
      <Footer />
    </div>
  );
}
